import { combineReducers } from 'redux';
import review from './review';

const rootReducer = combineReducers({
  review,
});
export default rootReducer;
